import http from './http';

export async function generateSortieQR(sortieId) {
  const { data } = await http.post(`/qr/sortie/${sortieId}/generate`);
  return data; // { token, type, residence_id, expires_at, sig, sortie_id }
}

export async function validateQR(payload) {
  const { data } = await http.post('/qr/validate', payload);
  return data;
}

export async function getQrConfig() {
  const { data } = await http.get('/qr/config');
  return data; // { signature_required: boolean }
}

export async function generateStudentQR(type = 'SORTIE', ttlSec) {
  const { data } = await http.post('/qr/student/generate', { type, ttlSec });
  return data; // { token, type, expires_at, sig }
}

export async function generateSupervisorSortieQR(sortieId) {
  const { data } = await http.post(`/qr/sortie/${sortieId}/generate-supervisor`);
  return data; // { token, type, residence_id, expires_at, sig, sortie_id }
}

export async function consumeSortieQR(payload) {
  const { data } = await http.post('/qr/consume-sortie', payload);
  return data;
}

export async function generateSupervisorReturnQR(sortieId) {
  const { data } = await http.post(`/qr/sortie/${sortieId}/generate-supervisor-return`);
  return data; // { token, type, residence_id, expires_at, sig, sortie_id }
}

export async function consumeReturnQR(payload) {
  const { data } = await http.post('/qr/consume-retour', payload);
  return data;
}

export async function getQrStatus(token) {
  const { data } = await http.get(`/qr/status/${token}`);
  return data; // { token, type, residence_id, expires_at, used_at, expired }
}
